(() => {
  const showPwaInstallButton = false;

  let deferredPrompt = null;

  const button = document.querySelector("[data-pwa-install-button]");

  if (!button) {
    return;
  }

  const isStandalone = () => {
    return (
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true
    );
  };

  const hideButton = () => {
    button.hidden = true;
    button.setAttribute("aria-hidden", "true");
  };

  const showButton = () => {
    if (isStandalone() || !showPwaInstallButton) {
      hideButton();
      return;
    }

    button.hidden = false;
    button.setAttribute("aria-hidden", "false");
  };

  hideButton();

  if (isStandalone()) {
    return;
  }

  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferredPrompt = event;
    showButton();
  });

  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    hideButton();
  });

  button.addEventListener("click", async () => {
    if (!deferredPrompt) {
      return;
    }

    deferredPrompt.prompt();

    try {
      await deferredPrompt.userChoice;
    } finally {
      deferredPrompt = null;
      hideButton();
    }
  });
})();
